module.exports = __webpack_public_path__ + "static/media/icon-inicio.d3479c73.svg";